l<template>
  <div class="villa-request-form-container">
    <!-- Back Button / Retour -->
    <div class="form-header d-flex align-items-center mb-2">
      <button class="back-button-form pl-0" @click="handleRetour">
        <i class="fas fa-chevron-left"></i>
        <span class="raleway-semi-p15">RETOUR</span>
      </button>
    </div>

    <!-- Form Title -->
    <div class="form-title-section mb-4">
      <h2 class="raleway-semi-p15 mb-3">RENSEIGNER VOS INFORMATIONS</h2>
      <p class="raleway-reg-p15">
        Un conseiller vous contactera pour vous apporter toutes les précisions et informations nécessaires sur cette maison et sur la création de vos vacances sur-mesure.
      </p>
    </div>

    <!-- Form Content -->
    <form @submit.prevent="handleSubmit" class="villa-request-form">
      <!-- Form User Info Container -->
      <div class="form-user-info">
        <!-- Name and First Name Row -->
        <div class="line-form row mb-4">
          <label for="last_name" class="col-12 col-md-6">
            Nom *
            <input
              id="last_name"
              v-model="formData.last_name"
              type="text"
              required
            />
          </label>
          <label for="first_name" class="col-12 col-md-6">
            Prénom *
            <input
              id="first_name"
              v-model="formData.first_name"
              type="text"
              required
            />
          </label>
        </div>

        <!-- Email Row -->
        <div class="line-form row mb-3">
          <label for="email" class="col-12">
            E-mail *
            <input
              id="email"
              v-model="formData.email"
              type="email"
              required
            />
          </label>
        </div>

        <!-- Phone Number Row -->
        <div class="line-form row mb-3">
          <label for="phone" class="col-12">
            Numéro de téléphone *
            <input
              id="phone"
              v-model="formData.phone"
              type="tel"
              required
            />
          </label>
          <p v-if="phoneError" class="phone-error-message ml-4 mt-0">{{ phoneError }}</p>
        </div>
        <!-- Questions Row -->
        <div class="line-form row mb-3">
          <label for="questions" class="col-12">
            Veuillez nous faire part de vos questions.
            <textarea
              id="questions"
              v-model="formData.questions"
              rows="5"
            />
          </label>
        </div>
      </div>

      <!-- Submit Button -->
      <div class="form-actions d-flex justify-content-center mt-3">
        <button
          type="submit"
          class="hortense-btn-primary"
          :disabled="isSubmitting"
        >
          {{ isSubmitting ? 'ENVOI EN COURS...' : 'ENVOYER MA DEMANDE' }}
        </button>
      </div>

      <!-- Error Message -->
      <div v-if="errorMessage" class="error-message mt-2 text-center">
        <p class="raleway-reg-p13" style="color: #D56A70;">{{ errorMessage }}</p>
      </div>

      <!-- Success Message -->
      <div v-if="successMessage" class="success-message mt-2 text-center">
        <p class="raleway-reg-p13" style="color: #2C5E4B;">{{ successMessage }}</p>
      </div>
    </form>
  </div>
</template>

<script>
export default {
  name: "VillaRequestForm",
  props: {
    lodging: {
      type: Object,
      required: true
    },
    item: {
      type: Object,
      required: true
    },
    from: {
      type: Date,
      required: false
    },
    to: {
      type: Date,
      required: false
    },
    user: {
      type: Object,
      required: false
    },
    numberOfPeople: {
      type: Number,
      required: false
    },
    selectedRate: {
      type: [String, Number],
      required: false
    },
    ratePerNight: {
      type: [String, Number],
      required: false
    },
    conditions: {
      type: [String, Object],
      required: false
    }
  },
  data() {
    return {
      formData: {
        last_name: '',
        first_name: '',
        email: '',
        phone: '',
        questions: ''
      },
      isSubmitting: false,
      errorMessage: '',
      successMessage: '',
      phoneError: ''
    };
  },
  mounted() {
    // Pre-fill form if user is logged in
    console.log('Conditions:', this.conditions);
    if (this.user) {
      this.formData.first_name = this.user.first_name || '';
      this.formData.last_name = this.user.last_name || '';
      this.formData.email = this.user.email || '';
      this.formData.phone = this.user.phone || '';
    }
  },
  methods: {
    async handleSubmit() {
      // Validate form

      this.phoneError = '';
      
      if (this.formData.phone.trim().length < 10) {
        this.phoneError = 'Le numéro de téléphone doit contenir au moins 10 caractères.';
        return;
      }
      if (!this.validateForm()) {
        this.errorMessage = 'Veuillez remplir tous les champs obligatoires.';
        return;
      }

      this.isSubmitting = true;
      this.errorMessage = '';
      this.successMessage = '';

      try {
        // Calculate number of nights
        let numberOfNights = 'Non spécifié';
        if (this.from && this.to) {
          const fromDate = new Date(this.from);
          const toDate = new Date(this.to);
          numberOfNights = Math.ceil((toDate - fromDate) / (1000 * 60 * 60 * 24));
        }

        const reservationState = JSON.parse(localStorage.getItem('reservationState'))
        const adults = this.numberOfPeople || 2;
        const childs = reservationState.childs || 0;

        // Prepare the data for FormSpree
        const formspreeData = {
          lodging_name: this.lodging.name,
          lodging_url: `https://www.hortense.green/reservation-hotel/${this.lodging.slug}`,
          last_name: this.formData.last_name,
          first_name: this.formData.first_name,
          email: this.formData.email,
          phone: this.formData.phone,
          questions: this.formData.questions || 'Non spécifié',
          check_in: this.from ? this.formatDate(this.from) : 'Non spécifié',
          check_out: this.to ? this.formatDate(this.to) : 'Non spécifié',
          number_of_nights: numberOfNights,
          number_of_people: (adults + childs) || 'Non spécifié',
          number_of_adults: adults || 'Non spécifié',
          number_of_children: childs || 'Non spécifié',
          selected_rate: this.selectedRate ? this.selectedRate + ' EUR' : 'Non spécifié',
          rate_per_night: this.ratePerNight ? this.ratePerNight + ' EUR' : 'Non spécifié',
          conditions: this.conditions ? (typeof this.conditions === 'string' ? this.conditions : JSON.stringify(this.conditions)) : 'Non spécifié'
        };

        // Send to FormSpree - Replace with your actual FormSpree endpoint
        const FORMSPREE_ID = 'xjgoplzk';
        const response = await fetch(`https://formspree.io/f/${FORMSPREE_ID}`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(formspreeData)
        });

        if (response.ok) {
          this.successMessage = 'Votre demande a bien été envoyée. Notre équipe revient vers vous dans les plus brefs délais.';
          this.resetForm();
          
          // Emit event to parent to close form after 2 seconds
          setTimeout(() => {
            this.$emit('request-submitted');
          }, 2000);
        } else {
          this.errorMessage = 'Une erreur est survenue lors de l\'envoi. Veuillez réessayer.';
        }
        window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: 'submit_info_villa',
            ecommerce: {
              last_name: this.formData.last_name,
              first_name: this.formData.first_name,
              email: this.formData.email,
              phone: this.formData.phone,
              lodging_name: this.lodging.name,
              check_in: this.from ? this.formatDate(this.from) : 'Non spécifié',
              check_out: this.to ? this.formatDate(this.to) : 'Non spécifié',
              number_of_people: this.numberOfPeople || 'Non spécifié',
              selected_rate: this.selectedRate ? this.selectedRate + ' EUR' : 'Non spécifié',
              rate_per_night: this.ratePerNight ? this.ratePerNight + ' EUR' : 'Non spécifié',
              conditions: this.conditions ? (typeof this.conditions === 'string' ? this.conditions : JSON.stringify(this.conditions)) : 'Non spécifié',
              items: [{
                item_name: this.lodging.name,
                item_id: this.lodging.id,
              }]
            },
          });
      } catch (error) {
        console.error('Error submitting form:', error);
        this.errorMessage = 'Une erreur est survenue lors de l\'envoi. Veuillez réessayer.';
      } finally {
        this.isSubmitting = false;
      }
    },
    validateForm() {
      return (
        this.formData.last_name.trim() !== '' &&
        this.formData.first_name.trim() !== '' &&
        this.formData.email.trim() !== '' &&
        this.formData.phone.trim() !== '' &&
        this.isValidEmail(this.formData.email)
      );
    },
    isValidEmail(email) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(email);
    },
    resetForm() {
      this.formData = {
        last_name: '',
        first_name: '',
        email: '',
        phone: '',
        questions: ''
      };
    },
    formatDate(date) {
      if (!date) return '';
      const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
      return new Date(date).toLocaleDateString('fr-FR', options);
    },
    handleRetour() {
      this.$emit('close');
    }
  }
};
</script>

<style lang="scss" scoped>
.villa-request-form-container {
  background: #ffffff;
  border-radius: 8px;
  margin: 0 auto;
}

.form-header {
  margin-bottom: 2rem;
  padding-bottom: 1rem;

  .back-button-form {
    background: none;
    border: none;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 0.5rem;
    font-weight: 600;
    transition: opacity 0.3s ease;
    color: black;

    &:hover {
      opacity: 0.8;
    }

    i {
      font-size: 1.2rem;
    }
  }
}

.form-title-section {
  h2 {
    color: #000;
    margin-bottom: 1rem;
    text-transform: uppercase;
  }

  .text-gray {
    color: #666;
    line-height: 1.6;
  }
}

.villa-request-form {
  .form-user-info {
    .line-form {
      @media only screen and (min-device-width: 320px) and (max-device-width: 480px) {
        flex-direction: column;
      }

      label {
        display: flex;
        flex-direction: column;
        font-family: 'Raleway', sans-serif;
        font-weight: 600;
        font-size: 15px;
        line-height: 18px;
      }

      input[type="text"],
      input[type="email"],
      input[type="tel"],
      textarea {
        border: 1px solid rgba(0, 0, 0, 0.5);
        padding: 16px;
        gap: 10px;
        height: 56px;
        border-radius: 8px;
        font-family: 'Raleway', sans-serif;
        font-size: 0.95rem;
        color: #333;
        margin-top: 8px;
        transition: border-color 0.3s ease, box-shadow 0.3s ease;

        @media only screen and (min-device-width: 320px) and (max-device-width: 480px) {
          width: 100%;
        }

        &:focus {
          outline: none;
          border-color: #2C5E4B;
          box-shadow: 0 0 0 3px rgba(44, 94, 75, 0.1);
        }

        &::placeholder {
          color: rgba(0, 0, 0, 0.5);
        }
      }

      textarea {
        height: auto;
        min-height: 140px;
        resize: vertical;
      }
    }
  }
}

.phone-error-message {
  color: #D56A70;
  font-size: 12px;
  margin-top: 8px;
  margin-bottom: 0;
  font-family: 'Raleway', sans-serif;
}

.form-actions {
  margin-top: 2rem;
  display: flex;
  justify-content: center;

  .submit-btn {
    min-width: 300px;
    padding: 1rem 2rem;
    font-size: 0.95rem;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    transition: background-color 0.3s ease;

    &:disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }

    &:hover:not(:disabled) {
      background-color: #1d4537;
    }

    @media (max-width: 768px) {
      min-width: 100%;
    }
  }
}

.error-message,
.success-message {
  padding: 1rem;
  border-radius: 4px;
  text-align: center;

  p {
    margin: 0;
  }
}
</style>
